<template>
  <v-layout row justify-center>
    <error-message ref="errorDialog" />
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      scrollable
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn block color="secondary" dark v-on="on"
          >上書きグラフ一覧を見る</v-btn
        >
      </template>
      <v-card tile>
        <v-toolbar card color="primary">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>上書きグラフ一覧</v-toolbar-title>
        </v-toolbar>
        <v-card-title class="font-weight-bold title secondary--text">
          元になったグラフ
        </v-card-title>
        <graph-card
          v-if="base_graph"
          :payload="base_graph[0]"
          @close-dialog="dialog = false"
        />
        <v-card-title class="font-weight-bold title secondary--text">
          みんなの上書きグラフ
        </v-card-title>
        <template v-for="(graph, index) in collated_graphs">
          <graph-card
            :key="index"
            :payload="graph"
            @close-dialog="dialog = false"
          />
          <v-divider
            v-if="index < collated_graphs.length - 1"
            :key="'divider' + index"
            class="divider"
          ></v-divider>
        </template>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import GraphCard from "@/views/detail/GraphCardForCollations.vue";
import dayjs from "dayjs";
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  components: {
    GraphCard,
    ErrorMessage
  },
  props: {
    is_overwrite: {
      type: Boolean,
      default: false
    },
    graph_id: {
      type: Number,
      default: 0
    },
    collate_graph_id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      base_graph: [],
      collated_graphs: [],
      dialog: false
    };
  },
  async created() {
    const id = this.is_overwrite ? this.collate_graph_id : this.graph_id;

    await this.getBaseGraph(id);
    await this.getCollatedGraphs(id);
  },
  methods: {
    getCollatedGraphs(id) {
      const EP = "/v1/graphs/collations/" + id;
      this.$http
        .get(EP, {
          headers: {
            Authorization: "Bearer " + this.$store.state.login.auth_token
          }
        })
        .then(res => {
          for (const key in res.data) {
            this.collated_graphs.push(res.data[key]);
          }
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "上書きしたグラフの取得に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    },
    getBaseGraph(id) {
      const EP = "/v1/graphs/" + id;
      this.$http
        .get(EP, {
          headers: {
            Authorization: "Bearer " + this.$store.state.login.auth_token
          }
        })
        .then(res => {
          this.base_graph.push(res.data);
        })
        .catch(error => {
          this.$refs.errorDialog.setMessage(
            "元グラフの取得に失敗しました。詳細：[" +
              error.response.status +
              "] " +
              error.response.statusText
          );
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.divider {
  width: 100%;
  border: none;
  border-top: dashed 1px #ff9933;
}
</style>
